import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/mail_main.svg';
const MailMain = () => React.createElement(IconSvg, null);
export default MailMain;
